var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fanoffer-preferences-view"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"offer-form-group__item"},[_c('offer',{attrs:{"offer":{
        id: 28,
        img: 'images/offers/fan_offer_tile.png',
        isChecked: true,
        offtype: 'partner',
        description: 'Sign in or create a Football Account and you go in the draw to win your very own signed CommBank Matildas or Socceroos jersey.',
        title: 'WIN',
        isFanOffer: true,
      }}})],1),_vm._v(" "),_vm._m(1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fanoffer-preferences-view__header"},[_c('h2',{staticClass:"common__heading bottom-gap-lg"},[_vm._v("Fan Offers")])])
},function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"common__sub-heading top-gap-25"},[_vm._v("Terms and Conditions\n      "),_c('a',{staticClass:"styled-form__link",attrs:{"href":"https://www.footballaustralia.com.au/sites/ffa/files/2021-12/21-1214%20-%20Create%20a%20Football%20Account%20Competition_Terms%20and%20Conditions_.pdf","target":"new"}},[_vm._v(" CLICK HERE ")])])
}]

export { render, staticRenderFns }